import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {ReactComponent as ArrowLeft} from '../../img/left-arrow.svg';
import {ReactComponent as ArrowRight} from '../../img/right-arrow.svg';
import {useStyles} from './helpers';

const TableCasino = ({allPage, perPage, columns, rows, changePage, route, changeRowsPerPage, width, pagination, selectId, setSelectId, setStep, order}) => {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage);

    return (
        <div style={{width: '100%', maxWidth: width}}>
            <TableContainer className={classes.container} >
            <Table stickyHeader aria-label="sticky table" >
                <TableHead >
                <TableRow style={{height: 25}}>
                    {columns.map((column, key) => (
                    <TableCell
                        key={column.id}
                        align={column.align}
                        onClick={() => {
                            if (order) {
                                order(column);
                            }
                        }}
                        style={{minWidth: column.minWidth, borderBottom: '1px solid #3a4b7e', backgroundColor: 'inherit', color: '#ffce01', fontFamily: 'PT Sans, sans-serif', fontSize: 12, fontWeight: 700, padding: 0, paddingLeft: key === 0 ? 10 : 0, margin: 0 }}
                    >
                        {column.label}
                    </TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody style={{width: '100%'}}>
                {
                    rows.map((row, key) => {
                        return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.code} style={{background: selectId.indexOf(row.id) !== -1 ? '#00e76e' : key % 2 === 0 ? '#141b33' : '#1b2039', cursor: 'pointer'}} onClick={() => {
                                const temp = selectId;
                                const index = temp.indexOf(row.id);
                                if (index === -1) {
                                    temp.push(row.id);
                                    setSelectId([...temp]);
                                } else {
                                    temp.splice(index, 1);
                                    setSelectId([...temp]);
                                }               
                            }}>
                                {
                                    columns.map((column, key) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={column.id} align={column.align} style={{border: 'none', color: '#f3f3f4', padding: 0, margin: 0, height: 30, paddingLeft: key === 0 ? 10 : 0}}>
                                                {column.format && typeof value === 'number' ? column.format(value) : value}
                                            </TableCell>
                                        );
                                    })
                                }
                            </TableRow>
                        );
                    })
                }
                </TableBody>
                
                
            </Table>
            {
                    rows.length === 0 &&
                  
                    <div style={{width: '100%', height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <span style={{color: '#7aa0c7', fontFamily: 'Roboto, sans-serif', fontWeight: 700, fontSize: 12}}>Данных нет</span>
                    </div>
                
                }
            </TableContainer>
            {
                pagination &&
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: 8}}>
                    <select 
                        className={classes.select}
                        value={rowsPerPage}
                        onChange={(v) => {
                            setRowsPerPage(v.target.value);
                            changeRowsPerPage({
                                page: page,
                                rowsPerPage: v.target.value
                            });
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    <input type="number" onChange={(v) => setPage(v.target.value)} value={page + 1} className={classes.inputnumber}/>
                    <span className={classes.countPage}>/ {allPage}</span>
                    <div style={{marginLeft: 12}}>
                        <span className={classes.arrowleft} onClick={() => {
                            if (page !== 0) {
                                changePage({page: page - 1, rowsPerPage: +rowsPerPage})
                                setPage(page - 1)
                            }
                            
                        }}>
                            <ArrowLeft style={{width: 10, height: 10, fill: '#0f3e67'}}/>
                        </span>
                        <span className={classes.arrowright} onClick={() => {
                            if (page !== +allPage - 1) {
                                changePage({page: page + 1, rowsPerPage: +rowsPerPage})
                                setPage(page + 1)
                            }
                        }}>
                            <ArrowRight style={{width: 10, height: 10, fill: '#0f3e67'}}/>
                        </span>
                    </div>
                </div>
            }
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, width: '100%'}}>
                <span style={{fontFamily: 'PT-sans, sans-serif', fontWeight: 700, fontSize: 18, width: '15%'}}>Выбранные игроки: {selectId.length}</span>
                {
                    !!selectId.length &&
                    <>
                        <div style={{
                            width: '65%', 
                            minHeight: '30px',
                            background: '#1a1c35',
                            border: '1px solid #24263e',
                            boxSizing: 'border-box',
                            borderRadius: '4px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            position: 'relative',
                            paddingRight: '25px',
                        }}>
                            {
                                selectId.map((item) => <span style={{
                                    height: 25, 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    background: 'rgba(0,163,249,.1)',
                                    borderRadius: '2px',
                                    padding: '3px 10px',
                                    margin: '3px',
                                    fontSize: '16px',
                                    lineHeight: '25px',
                                    color: '#00a3f9',
                                }}>ID {item}</span>)
                            }
                        </div>
                        <div style={{width: '15%'}}>
                            <span style={{
                                color: '#24263e', 
                                background: '#00e76e', 
                                borderRadius: 4, 
                                fontFamily: 'PT-sans, sans-serif', 
                                fontWeight: 700, 
                                lineHeight: 0, 
                                padding: 15, 
                                margin: 0,
                                cursor: 'pointer'
                            }}
                            onClick={() => setStep(2)}
                            >Выдать бонус</span>
                        </div>
                    </>
                }
                
            </div>
        </div>
    )
}

export default TableCasino;